/*
 Author: Amit Kumar Mehar

 This software is provided 'as-is', without any express or implied
 warranty.  In no event will the authors be held liable for any damages
 arising from the use of this software.
 Permission is granted to anyone to use this software for any purpose,
 including commercial applications, and to alter it and redistribute it
 freely, subject to the following restrictions:
 1. The origin of this software must not be misrepresented; you must not
 claim that you wrote the original software. If you use this software
 in a product, an acknowledgment in the product documentation would be
 appreciated but is not required.
 2. Altered source versions must be plainly marked as such, and must not be
 misrepresented as being the original software.
 3. This notice may not be removed or altered from any source distribution.
 */

var MakeWorldLoader = function(Box2D){
  const toWorldRatio = 300;
  var b2Vec2 =  Box2D.b2Vec2,
      b2AABB = Box2D.b2AABB,
      b2BodyDef = Box2D.b2BodyDef,
      b2Body = Box2D.b2Body,
      b2Filter = Box2D.b2Filter,
      b2FixtureDef = Box2D.b2FixtureDef,
      b2Fixture = Box2D.b2Fixture,
      b2World = Box2D.b2World,
      b2MassData = Box2D.b2MassData,
      b2PolygonShape = Box2D.b2PolygonShape,
      b2CircleShape = Box2D.b2CircleShape,
      b2DebugDraw = Box2D.b2DebugDraw,
      b2MouseJointDef =  Box2D.b2MouseJointDef,
      b2DistanceJointDef =  Box2D.b2DistanceJointDef,
      b2RevoluteJointDef =  Box2D.b2RevoluteJointDef,
      b2RopeJointDef = Box2D.b2RopeJointDef,
      b2WeldJointDef =  Box2D.b2WeldJointDef,
      b2PulleyJointDef = Box2D.b2PulleyJointDef,
      b2GearJointDef = Box2D.b2GearJointDef,
      b2PrismaticJointDef = Box2D.b2PrismaticJointDef;

  function createPolygonShape(vertices) {
    var shape = new Box2D.b2PolygonShape();
    var buffer = Box2D.allocate(vertices.length * 8, 'float', Box2D.ALLOC_STACK);
    var offset = 0;
    for (var i=0;i<vertices.length;i++) {
      Box2D.setValue(buffer+(offset), vertices[i].get_x(), 'float'); // x
      Box2D.setValue(buffer+(offset+4), vertices[i].get_y(), 'float'); // y
      offset += 8;
    }
    var ptr_wrapped = Box2D.wrapPointer(buffer, Box2D.b2Vec2);
    shape.Set(ptr_wrapped, vertices.length);
    return shape;
  }


  /** for bodies with texture data */
  function GameObject () {
      this.body;
      this.sprite;
      this.spriteData = [];
  }

  function WorldLoader (){
    this.loadedBodies = [];     // to store box2d bodies created to use when creating joints
    this.loadedJoints = [];     // to store box2d joints created
    this.gameObjects = [];      // to store gameobjects created
    this.offsetX = 0;
    this.offsetY = 0;
  }

  WorldLoader.prototype.reset = function(){
    if (this.loadedBodies.length > 0){
      delete(this.loadedBodies);
    }
    this.loadedBodies = [];

    if (this.loadedJoints.length > 0){
      delete(this.loadedJoints);
    }
    this.loadedJoints = [];

    if (this.gameObjects.length > 0){
      delete(this.gameObjects);
    }
    this.gameObjects = [];
  };

  WorldLoader.prototype.loadJsonScene = function(scene, world, transform){
    this.reset();

    // load bodies
    for (var i = 0; i < scene.bodies.length; i++){
      this.createBody(scene.bodies[i], world, transform);
    }

    // load joints
    for (var i = 0; i < scene.joints.length; i++){
      this.createJoint(scene.joints[i], world);
    }
  };

  WorldLoader.prototype.createBody = function(b, world, transform){
    var pB = b;

    var bodyDef = new b2BodyDef;
    bodyDef.set_type(pB.type);
    bodyDef.set_position(new b2Vec2(
      transform.x + pB.position[0] / toWorldRatio,
      transform.y + pB.position[1] / toWorldRatio
    ));
    bodyDef.set_angle(pB.rotation * Math.PI / 180);
    bodyDef.set_angularDamping(pB.angularDamping);
    bodyDef.set_bullet(pB.isBullet);
    bodyDef.set_fixedRotation(pB.isFixedRotation);
    bodyDef.set_linearDamping(pB.linearDamping);
    var body = world.CreateBody(bodyDef);

    this.loadedBodies.push(body);

    if (pB.texture){
      this.createGameObject(pB.texture, pB.textureData, body);
    }

    for (var i = 0; i < pB.fixtures.length; i++){
      var f = pB.fixtures[i];
      var fixture = new b2FixtureDef;
      fixture.set_density(f.density);
      fixture.set_restitution(f.restitution);
      fixture.set_friction(f.friction);
      fixture.set_isSensor(f.isSensor);
      var filter = new b2Filter;
      filter.set_maskBits(parseInt(f.maskBits));
      filter.set_categoryBits(parseInt(f.categoryBits));
      filter.set_groupIndex(parseInt(f.groupIndex));
      fixture.set_filter(filter);

      for (var j = 0; j < f.shapes.length; j++){
          var s = f.shapes[j];
          if (s.type == 0) {
              var shape = new b2PolygonShape;
              shape.SetAsBox(s.width / toWorldRatio * 2, s.height / toWorldRatio * 2);
              //shape.set_position(new b2Vec2(s.position[0] / toWorldRatio, s.position[1] / toWorldRatio));
              //var shape = createPolygonShape(verts);
              fixture.set_shape(shape)
              body.CreateFixture(fixture);
          } else if (s.type == 1) {
            const radius = s.radius * 2 /toWorldRatio;
            var shape = new b2CircleShape();
            shape.set_m_radius(radius);
            shape.set_m_p(new b2Vec2(s.position[0] / toWorldRatio, s.position[1] / toWorldRatio));
            fixture.set_shape(shape);
            body.CreateFixture(fixture);
          } else if (s.type == 2) {
            var shape = new b2PolygonShape;
            var verts = [];
            for (var k = 0; k < s.vertices.length; k++){
              var vert = new b2Vec2(s.position[0] / toWorldRatio + s.vertices[k][0] / toWorldRatio, s.position[1] / toWorldRatio + s.vertices[k][1] / toWorldRatio);
              verts.push(vert); 
            }

            /*
              var verts = [];
              
              for(var k = 0; k < s.m_vertices.length; k++){
                verts.push(
                  new b2Vec2(
                    (shape.m_vertices[k].x + s.position[0]) / toWorldRatio
                    (shape.m_vertices[k].y + s.position[1]) / toWorldRatio
                ))
              }
*/
              var shape = createPolygonShape(verts);

            shape.SetAsArray(verts);
            fixture.set_shape(shape);
            body.CreateFixture(fixture);
          } else if (s.type == 3) {
            var shape = new b2PolygonShape;
                fixture.shape = shape;
            for (var k = 0; k < s.vertices.length; k++){
              var vert1 = new b2Vec2(s.position[0] / toWorldRatio + s.vertices[k][0] / toWorldRatio, s.position[1] / toWorldRatio + s.vertices[k][1] / toWorldRatio);
              var vert2 = new b2Vec2(s.position[0] / toWorldRatio + s.vertices[k < s.vertices.length - 1 ? k + 1 : 0][0] / toWorldRatio, s.position[1] / toWorldRatio + s.vertices[k < s.vertices.length - 1 ? k + 1 : 0][1] / toWorldRatio);
              shape.SetAsEdge(vert1, vert2);
              fixture.set_shape(shape);
              body.CreateFixture(fixture);
            }
          }
      }
    }
  };

  WorldLoader.prototype.createJoint = function(j, world){
    if (j.jointType == 0) {
      var jointDef = new b2DistanceJointDef;
      jointDef.set_bodyA(this.loadedBodies[j.bodyA]);
      jointDef.set_bodyB(this.loadedBodies[j.bodyB]);
      jointDef.set_localAnchorA(new b2Vec2(j.localAnchorA[0] / toWorldRatio, j.localAnchorA[1] / toWorldRatio));
      jointDef.set_localAnchorB(new b2Vec2(j.localAnchorB[0] / toWorldRatio, j.localAnchorB[1] / toWorldRatio));
      jointDef.set_collideConnected(j.collideConnected);
      jointDef.set_length(j.length / 30);
      jointDef.set_dampingRatio(j.dampingRatio);
      jointDef.set_frequencyHz(j.frequencyHZ);
      this.loadedJoints.push(world.CreateJoint(jointDef));
    }
    else if (j.jointType == 1) {
      var jointDef = new b2WeldJointDef;
      jointDef.set_bodyA(this.loadedBodies[j.bodyA]);
      jointDef.set_bodyB(this.loadedBodies[j.bodyB]);
      jointDef.set_localAnchorA(new b2Vec2(j.localAnchorA[0] / toWorldRatio, j.localAnchorA[1] / toWorldRatio));
      jointDef.set_localAnchorB(new b2Vec2(j.localAnchorB[0] / toWorldRatio, j.localAnchorB[1] / toWorldRatio));
      jointDef.set_collideConnected(j.collideConnected);
      jointDef.set_referenceAngle(j.referenceAngle * Math.PI / 180);
      this.loadedJoints.push(world.CreateJoint(jointDef));
      }
    else if (j.jointType == 2) {
      var jointDef = new b2RevoluteJointDef;
      jointDef.set_bodyA(this.loadedBodies[j.bodyA]);
      jointDef.set_bodyB(this.loadedBodies[j.bodyB]);
      jointDef.set_localAnchorA(new b2Vec2(j.localAnchorA[0] / toWorldRatio, j.localAnchorA[1] / toWorldRatio));
      jointDef.set_localAnchorB(new b2Vec2(j.localAnchorB[0] / toWorldRatio, j.localAnchorB[1] / toWorldRatio));
      jointDef.set_collideConnected(j.collideConnected);
      jointDef.set_enableLimit(j.enableLimit);
      jointDef.set_enableMotor(j.enableMotor);
      jointDef.set_lowerAngle(j.lowerAngle * Math.PI / 180);
      jointDef.set_maxMotorTorque(j.maxMotorTorque);
      jointDef.set_motorSpeed(j.motorSpeed);
      jointDef.set_referenceAngle(j.referenceAngle * Math.PI / 180);
      jointDef.set_upperAngle(j.upperAngle * Math.PI / 180);
      this.loadedJoints.push(world.CreateJoint(jointDef));
    }
    else if (j.jointType == 4) {
      var jointDef = new b2PulleyJointDef;
      jointDef.set_bodyA(this.loadedBodies[j.bodyA]);
      jointDef.set_bodyB(this.loadedBodies[j.bodyB]);
      jointDef.set_localAnchorA(new b2Vec2(j.localAnchorA[0] / toWorldRatio, j.localAnchorA[1] / toWorldRatio));
      jointDef.set_localAnchorB(new b2Vec2(j.localAnchorB[0] / toWorldRatio, j.localAnchorB[1] / toWorldRatio));
      jointDef.set_collideConnected(j.collideConnected);
      jointDef.set_groundAnchorA(new b2Vec2(j.groundAnchorA[0] / toWorldRatio, j.groundAnchorA[1] / toWorldRatio));
      jointDef.set_groundAnchorB(new b2Vec2(j.groundAnchorB[0] / toWorldRatio, j.groundAnchorB[1] / toWorldRatio));
      jointDef.set_lengthA(j.lengthA / toWorldRatio);
      jointDef.set_lengthB(j.lengthB / toWorldRatio);
      //jointDef.set_maxLengthA(j.maxLengthA / toWorldRatio);
      //jointDef.set_maxLengthB(j.maxLengthB / toWorldRatio);
      jointDef.set_ratio(j.ratio);
      this.loadedJoints.push(world.CreateJoint(jointDef));
    }
    else if (j.jointType == 5) {
      var jointDef = new b2GearJointDef;
      jointDef.set_bodyA(this.loadedBodies[j.bodyA]);
      jointDef.set_bodyB(this.loadedBodies[j.bodyB]);
      jointDef.set_joint1(this.loadedJoints[j.joint1]);
      jointDef.set_joint2(this.loadedJoints[j.joint2]);
      jointDef.set_collideConnected(j.collideConnected);
      jointDef.set_ratio(j.ratio);
      this.loadedJoints.push(world.CreateJoint(jointDef));
    }
    else if (j.jointType == 6) {
      var jointDef = new b2PrismaticJointDef;
      jointDef.set_bodyA(this.loadedBodies[j.bodyA]);
      jointDef.set_bodyB(this.loadedBodies[j.bodyB]);
      jointDef.set_localAnchorA(new b2Vec2(j.localAnchorA[0] / toWorldRatio, j.localAnchorA[1] / toWorldRatio));
      jointDef.set_localAnchorB(new b2Vec2(j.localAnchorB[0] / toWorldRatio, j.localAnchorB[1] / toWorldRatio));
      jointDef.set_localAxisA(new b2Vec2(j.localAxisA[0], j.localAxisA[1]));
      jointDef.set_collideConnected(j.collideConnected);
      jointDef.set_enableLimit(j.enableLimit);
      jointDef.set_enableMotor(j.enableMotor);
      jointDef.set_lowerTranslation(j.lowerTranslation / toWorldRatio);
      jointDef.set_maxMotorForce(j.maxMotorForce);
      jointDef.set_motorSpeed(j.motorSpeed);
      jointDef.set_referenceAngle(j.referenceAngle * Math.PI / 180);
      jointDef.set_upperTranslation(j.upperTranslation / toWorldRatio);
      this.loadedJoints.push(world.CreateJoint(jointDef));
    }

    // wheel joint is not supported in box2d-web
    else if (j.jointType == 3) {
    //  for (var f = this.loadedBodies[j.bodyA].GetFixtureList(); f != null; f = f.GetNext()){
      //  f.m_filter.groupIndex = -1;
      // }
      // for (var f = this.loadedBodies[j.bodyB].GetFixtureList(); f != null; f = f.GetNext()){
      //  f.m_filter.groupIndex = -1;
      // }
      // create a new body to use as axle
      // var shape = new b2CircleShape(10 / toWorldRatio);
      // var fixture = new b2FixtureDef;
      // fixture.density = 0;
      // fixture.restitution = 0;
      // fixture.friction = 0;
      // fixture.shape = shape;
      // fixture.isSensor = true;
    //  var bodyDef = new b2BodyDef;
    //  bodyDef.type = b2Body.b2_dynamicBody;
    //  bodyDef.position.Set(this.loadedBodies[j.bodyB].GetPosition().x + j.localAnchorB[0] / toWorldRatio, this.loadedBodies[j.bodyB].GetPosition().y + j.localAnchorB[1] / toWorldRatio);
    //  var axle = world.CreateBody(bodyDef);
    //  axle.CreateFixture(fixture);

     //    var revJointDef = new b2RevoluteJointDef;
     //    revJointDef.bodyA = this.loadedBodies[j.bodyA];
     //    revJointDef.bodyB = axle;
     //    revJointDef.localAnchorA = new b2Vec2(axle.GetPosition().x - this.loadedBodies[j.bodyA].GetPosition().x,
     //                      axle.GetPosition().y - this.loadedBodies[j.bodyA].GetPosition().y);//new b2Vec2(j.localAnchorA[0] / toWorldRatio, j.localAnchorA[1] / toWorldRatio);
     //    revJointDef.localAnchorB = new b2Vec2(0, 0);
     //    revJointDef.collideConnected = false;
     //    revJointDef.enableMotor  = j.enableMotor;
     //    revJointDef.maxMotorTorque = j.maxMotorTorque;
     //    revJointDef.motorSpeed   = j.motorSpeed;
     //    world.CreateJoint(revJointDef);

     //    var distJointDef = new b2DistanceJointDef;
     //    distJointDef.bodyA = axle;
     //    distJointDef.bodyB = this.loadedBodies[j.bodyB];
     //    distJointDef.localAnchorA = new b2Vec2(0, 0);
     //    distJointDef.localAnchorB = new b2Vec2(0,0);
     //    distJointDef.collideConnected = false;
     //    distJointDef.length = 1 / toWorldRatio;
     //    distJointDef.dampingRatio = j.dampingRatio;
     //    distJointDef.frequencyHz = j.frequencyHZ;
     //    world.CreateJoint(distJointDef);
    }

    // not supported bu box2d-web
    else if (j.jointType == 7) {
      var jointDef = new b2RopeJointDef();
      jointDef.set_bodyA(this.loadedBodies[j.bodyA]);
      jointDef.set_bodyB(this.loadedBodies[j.bodyB]);
      jointDef.set_localAnchorA(new b2Vec2(j.localAnchorA[0] / toWorldRatio, j.localAnchorA[1] / toWorldRatio));
      jointDef.set_localAnchorB(new b2Vec2(j.localAnchorB[0] / toWorldRatio, j.localAnchorB[1] / toWorldRatio));
      jointDef.set_collideConnected(j.collideConnected);
      jointDef.set_maxLength(j.maxLength / toWorldRatio);
      //intDef.set_maxLength(0.4);

      this.loadedJoints.push(world.CreateJoint(jointDef));

    }
  };

  WorldLoader.prototype.createGameObject = function(texture, textureData, body){
    var gameObject = new GameObject();
      gameObject.sprite = new Image();
      gameObject.sprite.src = texture;
  
    if (textureData.length == 2){
        gameObject.sprite.width = textureData[0];
        gameObject.sprite.height = textureData[1];  
    }
      else {
      gameObject.spriteData[0] = textureData[0];
        gameObject.spriteData[1] = textureData[1];
        gameObject.spriteData[2] = textureData[2];
        gameObject.spriteData[3] = textureData[3];
        gameObject.spriteData[4] = textureData[4];
        gameObject.spriteData[5] = textureData[5];
      }

      gameObject.body = body;
      this.gameObjects.push(gameObject);
  };

  return new WorldLoader();
};
export default {
  MakeWorldLoader
}
